import React from 'react';
import { CloseIcon } from '../../../../../base/ui/svg/AmsaleIcons';
import { mainMenuData } from '../../../../../base/ui/menuData/MenuTree';
import MobileLinks from '../../../../../base/ui/MobileLinks';

function MobileMenu({ handleCloseMenu }) {
  return (
    <div className="mobile-menu mobile-menu-drawer">
      <div className="drawer-inner-content">
        <div className="drawer-header">
          <a href="#" className="close-drawer close-drawer-btn" onClick={handleCloseMenu}>
            <CloseIcon />
          </a>
        </div>

        <nav className="main-nav-mobile" role="navigation" aria-label="Mobile Main Navigation">
          <ul className="mobile-navlist" role="menubar">
            <MobileLinks mainMenu={mainMenuData.left} />
            <MobileLinks mainMenu={mainMenuData.right} />
            <li className="list-item normal-link" role="none">
              <a className="mobile-link" href={`${process.env.PROXY_PATH}/profile`} role="menuitem">
                Account
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}
export default MobileMenu;
